// @ts-nocheck
// @ts-ignore
import { Component } from '@theme/component';

export class Breadcrumb extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.#initialize();
  }

  #initialize() {
    this.#buildDynamicBreadcrumb();
  }

  #buildDynamicBreadcrumb() {
    const referrer = sessionStorage.getItem('navigationReferrer');
    const pageType = this.dataset.pageType || 'product';

    if (!referrer || this.#isHomepage(referrer)) {
      return;
    }

    if (pageType === 'product' || pageType === 'collection') {
      const collectionPath = this.#extractCollectionPath(referrer);
      if (collectionPath.length > 0) {
        this.#injectCollectionBreadcrumbs(collectionPath);
        this.#updateStructuredData(collectionPath);
      }
    }
  }

  #isHomepage(url) {
    const urlObj = new URL(url);
    const pathname = urlObj.pathname;
    return pathname === '/' || pathname === '' || pathname === '/index';
  }

  #extractCollectionPath(referrer) {
    const urlObj = new URL(referrer);
    const pathname = urlObj.pathname;
    const collectionMatch = pathname.match(/^\/collections\/(.+?)(?:\/|$)/);

    if (!collectionMatch) {
      return [];
    }

    const collections = [];
    const fullPath = collectionMatch[1];
    const pathSegments = fullPath.split('/').filter(segment => segment.length > 0);
    let accumulatedPath = '';

    pathSegments.forEach((segment) => {
      if (segment.includes('?') || segment === 'all') {
        return;
      }

      accumulatedPath = accumulatedPath
        ? `${accumulatedPath}/${segment}`
        : segment;

      collections.push({
        title: this.#getCollectionTitle(accumulatedPath),
        url: `/collections/${accumulatedPath}`,
        handle: accumulatedPath
      });
    });

    if (collections.length === 0 && fullPath) {
      collections.push({
        title: this.#getCollectionTitle(fullPath),
        url: `/collections/${fullPath}`,
        handle: fullPath
      });
    }

    return collections;
  }

  #getCollectionTitle(handle) {
    const storedTitle = sessionStorage.getItem(`collectionTitle:${handle}`);
    if (storedTitle) {
      return storedTitle;
    }

    const metaTitle = document.querySelector(`meta[property="collection:${handle}"]`);
    if (metaTitle) {
      return metaTitle.getAttribute('content');
    }

    return handle
      .split('-')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }

  #injectCollectionBreadcrumbs(collections) {
    const currentItem = this.refs.currentItem;
    if (!this.refs.list || !currentItem) {
      return;
    }

    collections.forEach((collection) => {
      const listItem = document.createElement('li');
      listItem.className = 'breadcrumb__item flex items-start';

      const separator = document.createElement('span');
      separator.className = 'breadcrumb__separator';
      separator.setAttribute('aria-hidden', 'true');
      separator.style.color = 'var(--breadcrumb-link-color, #CCCCCC)';
      separator.style.margin = '0 2px';
      separator.textContent = '/';

      const link = document.createElement('a');
      link.href = collection.url;
      link.className = 'breadcrumb__link transition-colors duration-150 athletics-regular text-sm leading-none tracking-normal';
      link.style.color = 'var(--breadcrumb-link-color, #CCCCCC)';
      link.style.setProperty('--text-size', '14px');
      link.style.verticalAlign = 'middle';
      link.textContent = collection.title;

      listItem.appendChild(separator);
      listItem.appendChild(link);
      this.refs.list.insertBefore(listItem, currentItem);
    });
  }

  #updateStructuredData(collections) {
    const structuredDataScript = this.querySelector('script[type="application/ld+json"]');
    if (!structuredDataScript) {
      return;
    }

    try {
      const data = JSON.parse(structuredDataScript.textContent);
      const itemListElement = data.itemListElement || [];
      let position = 2;

      collections.forEach((collection) => {
        itemListElement.splice(position - 1, 0, {
          '@type': 'ListItem',
          position: position,
          name: collection.title,
          item: `${window.location.origin}${collection.url}`
        });
        position++;
      });

      const productItem = itemListElement[itemListElement.length - 1];
      if (productItem) {
        productItem.position = position;
      }

      data.itemListElement = itemListElement;
      structuredDataScript.textContent = JSON.stringify(data);
    } catch {}
  }
}

if (!customElements.get('breadcrumb-component')) {
  customElements.define('breadcrumb-component', Breadcrumb);
}


